// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfn_a bik_tr","StrollerBoxWidget__imageCounselling":"bfn_b bik_kg"};